import {
  HalfHourlyValue,
  IElecNominationsData,
} from "@/models/operations/tradingData/elecNominationsData.types"
import { Dayjs } from "dayjs"

export class TradeElecNominations implements IElecNominationsData {
  constructor(
    public date: Dayjs,
    public createdAt: Dayjs,
    public updatedAt: Dayjs,
    public halfHourlyValues: Array<HalfHourlyValue>,
    public trader: string,
  ) {}
}
